/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:30
 * @LastEditors: yy
 * @LastEditTime: 2020-08-19 11:27:59
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// @ts-ignore
import s from './CustomChart.css';
import ExportEcharts from '../ExportEcharts/ExportEcharts';


const scaleToPx = (str, relative) => {
  return parseInt(String(str).replace(/(.+)([\%]|px)/, (all, num, unit) => {
    if (unit === 'px') return num;
    return (num * 0.01 * relative) 
  }))
}

class CustomChart extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      brandId: 1,
      links: this.props.links || [],
      visible: !false,
    };

    this.toggle = this.toggle.bind(this);
  }

  static defaultprops = {
    chart: {},
    width: 1280,
    height: 720
  }

  getBodyHeight () {
    let height = 700
    // @ts-ignore
    if (global.window === global) {
      height = global.document.body.offsetHeight
    }
    return height
  }

  toggle () {
    this.setState({
      visible: !this.state.visible
    })
  }

  render () {
    const {visible} = this.state;
    const {width, height, chartPane, callback} = this.props;
    const bodyHeight = this.getBodyHeight()
    const _width = scaleToPx(width, 1280)
    const _height = scaleToPx(height, 720)
    
    const scale = _height > bodyHeight  ? (bodyHeight / _height - 0.01).toFixed(2) : 1
    

    let style = {
      width: _width + 'px',
      height: _height + 'px',
      transform: `scale(${scale})`,
      transformOrigin: '0 0'
    }

    return (
      <div className={s.container}>
        <div className={s.toolBtn} onClick={this.toggle}> Set </div>
        <div className={[s.toolWrapper, visible ? '' : s.hide].join(' ')}>
          {this.props.children}
          <div className={s.createButton} onClick={() => callback && callback()}> 生成图表 </div>
        </div>

        <div style={style} className={s.chartWrapper}>
          {!chartPane ? <ExportEcharts option={this.props.chart} /> : chartPane()}
        </div>
        {/* <div className={s.chartBox}>
        </div> */}
      </div>
    );
  }
}

export default withStyles(s)(CustomChart);


// WEBPACK FOOTER //
// src/components/CustomChart/CustomChart.js